import React from 'react'
import {Route, Switch} from 'react-router-dom'

import {RequireAuth, RequireAdmin} from '../utils/auth'


import Layout from '../views/Layout'
import Login from '../views/Auth/Login'


import ResetPassword from '../views/Auth/ResetPassword/resetPassword';
import VerifyEmail from '../views/Auth/VerifyEmail/verifyEmail';
import CloudProviders from '../components/CloudProviders';

import productPackagesDashboard from '../views/ProductPackages/productPackagesDashboard.jsx';
import addNewPackage from '../views/ProductPackages/AddNewPackage/addNewPackage';
import editPackage from '../views/ProductPackages/EditPackage/editPackage';

import productSubscriptionDashboard from '../views/SubscriptionAdmin/productSubscriptionDashboard';
import addNewSubscription from '../views/SubscriptionAdmin/AddNewSubscription/addNewSubscription';
import editSubscription from '../views/SubscriptionAdmin/EditSubscription/editSubscription';
import productFeaturesDashboard from '../views/ProductFeatures/productFeaturesDashboard.jsx';
import addNewFeature from '../views/ProductFeatures/AddNewFeature/addNewFeature';
import editFeature from '../views/ProductFeatures/EditFeature/editFeature';
import UserDashboard from '../views/UsersListDashboard/usersListDashboard';
import EachUserDashboard from '../views/UserDashboard/userDashboard';
import UsageDetail from '../views/UsersListDashboard/UsageDetail/usageDetail';
import TransferCostDetail from '../views/UsersListDashboard/UsageDetail/TransferCostDetail/transferCostDetail';

import AdminDashboard from '../views/AdminDashboard/adminDashboard';
import AdmindAccount from '../views/AdminAccount/adminAccount';
import AddNewAccount from '../views/AdminAccount/AddNewAccount/addNewAccount';
import AddNewUser from '../views/UsersListDashboard/AddNewUser/addNewUser';
import AdminSyncReport from '../views/AdminSyncReport';
import AdminTransferReport from '../views/AdminTransferReport';

import Notifications from '../views/Notifications/index';
import Xchange from '../views/Xchange/index';

export default (
  <Switch>
    <Route path="/login/:referrer_id?" component={Login} />




    {/* wasabi only =========================== */}
    <Route path="/resetpasswords/:token?" component={ResetPassword}/>
    <Route path="/verifyemail" component={VerifyEmail}/>

    <Layout path="/cloudproviders" component={RequireAuth(CloudProviders)} />

    <Layout path="/notifications" component={RequireAuth(Notifications)} />
    <Layout path="/migration" component={RequireAuth(Xchange)} />


    <Layout path="/userDashboard" component={RequireAuth(EachUserDashboard)} />
    <Layout path="/usageDetail" component={RequireAuth(UsageDetail)} />
    <Layout path="/transferCostDetail" component={RequireAuth(TransferCostDetail)} />

    <Layout path="/transferReport" component={RequireAuth(AdminTransferReport)} />
    <Layout path="/syncReport" component={RequireAuth(AdminSyncReport)} />
    <Layout path="/userList" component={RequireAuth(UserDashboard)} />

    <Layout path="/subscriptionAdmin" component={RequireAuth(productSubscriptionDashboard)} />
    <Layout path="/addNewSubscription" component={RequireAuth(addNewSubscription)} />
    <Layout path="/editSubscription" component={RequireAuth(editSubscription)} />
    <Layout path="/productPackages" component={RequireAuth(productPackagesDashboard)} />
    <Layout path="/editPackage" component={RequireAuth(editPackage)} />
    <Layout path="/addNewPackage" component={RequireAuth(addNewPackage)} />

    <Layout path="/productFeatures" component={RequireAuth(productFeaturesDashboard)} />
    <Layout path="/editFeature" component={RequireAuth(editFeature)} />
    <Layout path="/addNewFeature" component={RequireAuth(addNewFeature)} />
    <Layout path="/admindaccount" component={RequireAuth(AdmindAccount)} />
    <Layout path="/addNewAccount" component={RequireAuth(AddNewAccount)} />
    <Layout path="/addNewUser" component={RequireAuth(AddNewUser)} />
    <Layout path="/" component={RequireAuth(AdminDashboard)} />

    {/* ======================================== */}



  </Switch>
)
